import "./Modal.scss";
import Button from "../Button/Button";
import close from "../../assets/icons/close.png";

const Modal = ({ openModal, setOpenModal, onClickHandler, id }) => {
  if (!openModal) {
    return;
  }
  return (
    <section className="modal">
      <div className="modal__wrapper">
        <div className="modal__container-top">
          <img
            src={close}
            alt="Close icon"
            className="modal__img"
            onClick={() => {
              setOpenModal(false);
            }}
          />
          <h1 className="modal__header">
            {id ? "Delete Confirmation" : "Logout"}
          </h1>
        </div>
        <div className="modal__container-bottom">
          <p className="modal__text">
            Are you sure you want to{" "}
            {id ? "delete this scheduled post" : "log out"}?
          </p>
          <div className="modal__buttons">
            <Button
              type="cancel"
              label="Cancel"
              action={() => {
                setOpenModal(false);
              }}
            />
            <Button
              type={`${id ? "delete" : "logout"}`}
              label={`${id ? "Delete" : "Logout"}`}
              action={() => {
                setOpenModal(false);
                onClickHandler(id);
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Modal;
